import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { resolvePage, trackPageView } from './events';

// Fires a normalized `$pageview` on every React Router navigation. The SDK's
// auto pageview is disabled (`capture_pageview: false`) because it only
// fires on full loads and would double-count the first render; this effect
// covers the initial mount and every subsequent route change. Renders
// nothing. `trackPageView` is a no-op when PostHog is unconfigured, so this
// is safe to mount unconditionally.
export function RouteAnalytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(resolvePage(pathname));
  }, [pathname]);

  return null;
}
